import { generarTimeSlots, sumarMinutos, rangosSeSolapan } from './timeUtils';
import { formatIsoPrTime, formatIsoPrDay, formatIsoPrDateKey } from './prTime';

const diasSemana = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];

export function obtenerHorariosDisponibles({ fecha, duracion, citas, horarioBase }) {
  console.log("🔍 Iniciando obtenerHorariosDisponibles");
  console.log("📅 Fecha recibida:", fecha);
  console.log("⏱️ Duración:", duracion);
  console.log("📋 Horario base completo:", JSON.stringify(horarioBase, null, 2));

  if (!Number.isInteger(duracion) || duracion <= 0) {
    console.error("Duración inválida:", duracion);
    return {};
  }

  const disponibilidad = {};
  const enfermeros = Object.keys(horarioBase.porEnfermero || {});
  console.log("👥 Enfermeros encontrados:", enfermeros);

  const dia = formatIsoPrDay(fecha) || diasSemana[new Date(`${fecha}T12:00:00Z`).getUTCDay()];
  console.log("📆 Día calculado:", dia);

  for (const enfermeroId of enfermeros) {
    console.log("🔄 Procesando enfermero:", enfermeroId);
    const horarioEnfermero = horarioBase.porEnfermero[enfermeroId];
    const bloquesDia = horarioEnfermero?.[dia];
    console.log(`📅 Horarios para ${enfermeroId} el día ${dia}:`, bloquesDia);

    if (!Array.isArray(bloquesDia)) {
      console.warn("⚠️ No hay bloques para", enfermeroId, "el día", dia);
      continue;
    }

    for (const bloque of bloquesDia) {
      if (!bloque?.inicio || !bloque?.fin) {
        console.warn(`⛔ Bloque inválido de ${enfermeroId}:`, bloque);
        continue;
      }

      console.log(`⏰ Generando slots para bloque`, bloque);
      const slots = generarTimeSlots(bloque.inicio, bloque.fin, duracion, fecha, true);
      console.log(`✅ Slots generados para ${enfermeroId}:`, slots);

  for (const hora of slots) {
  const horaFin = sumarMinutos(hora, duracion);
  const fechaISO = formatIsoPrDateKey(fecha);

  const citasDelDia = citas.filter(c => {
    if (!c.fecha) return false;
    const fechaCita = formatIsoPrDateKey(c.fecha);
    return (
      fechaCita === fechaISO &&
      c.enfermeroId === enfermeroId &&
      c.hora
    );
  });

  const ocupado = citasDelDia.some(cita => {
    let citaHora24 = cita.hora;
    if (cita.hora && (cita.hora.includes('AM') || cita.hora.includes('PM'))) {
      const [time, ampm] = cita.hora.trim().split(' ');
      let [hours, minutes] = time.split(':').map(Number);
      if (ampm.toUpperCase() === 'PM' && hours !== 12) hours += 12;
      if (ampm.toUpperCase() === 'AM' && hours === 12) hours = 0;
      citaHora24 = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }

    const citaFin = sumarMinutos(citaHora24, cita.duracion || 60);
    return rangosSeSolapan(hora, horaFin, citaHora24, citaFin);
  });

  if (!ocupado) {
    if (!disponibilidad[hora]) disponibilidad[hora] = [];

    if (!disponibilidad[hora].includes(enfermeroId)) {
      disponibilidad[hora].push(enfermeroId);
      console.log(`💡 ${enfermeroId} agregado como disponible para ${hora}`);
    }
  } else {
    console.log(`⛔️ ${enfermeroId} ocupado o no disponible para ${hora}`);
  }
      }
    }
  }

  console.log("📊 Enfermeros con disponibilidad por slot:");
  for (const [slot, ids] of Object.entries(disponibilidad)) {
    console.log(`${slot} → ${ids.join(', ')}`);
  }

  console.log("🧠 Disponibilidad final generada:", disponibilidad);
  return disponibilidad;
}
  
export function construirHorarioPorEnfermero(bloques) {
  const resultado = {};

  for (const bloque of bloques) {
    const { enfermeroId, start, end } = bloque;
    if (!start || !end) continue;

    const dia = formatIsoPrDay(start) || "lunes";

    if (!resultado[enfermeroId]) resultado[enfermeroId] = {};
    if (!resultado[enfermeroId][dia]) resultado[enfermeroId][dia] = [];

    const inicio = formatIsoPrTime(start);
    const fin = formatIsoPrTime(end);

    resultado[enfermeroId][dia].push({ inicio, fin });
  }

  console.log(
    " Horario generado:",
    JSON.stringify({ porEnfermero: resultado }, null, 2)
  );

  return { porEnfermero: resultado };
}
